<div class="lidl-lib-content-fe">
    <h2>{{(content$ | async)?.title}}</h2>
    <p [innerHTML]="(content$ | async)?.text"></p>
</div>
